<template>
    <div class="audio-embed">
        <div v-if="track.embed" v-html="track.embed"></div>
        <p v-else>Audio embed non disponibile</p>
    </div>
</template>
<script setup lang="ts">
import type { Audio } from '../../shared/types/audio.type'

const props = defineProps<{
    track: Audio
}>()
</script>

<style scoped>
.audio-embed {
    position: relative;
    padding-bottom: 56.25%;
    /* 16:9 */
    height: 0;
    overflow: hidden;
    max-width: 100%;
    margin-top: 4rem;
}
</style>